import SubscribersProcessor from './SubscribersProcessor';

// @FIXME: APIFIX: Investigate all errors types again

/**
 * Defaults to base OMFETopic provision on
 */
const defaultOptions = {
    // topic name construction - parameters parsing and defaults go here, should return a string
    topicName: (params) => JSON.stringify(params),

    // response validator - should return true or false, when initial dump is invalid
    validateInitialDump: data => data && data.kwargs && data.kwargs.records && data.kwargs.version,

    // check whether a response qualifies as an error (ex.: error key presence etc.)
    isErrorInitialDump: data => data && data.kwargs && data.kwargs.error,

    // response parser - this is to reformat the data pulled from initial dump (ex.: kwargs removal)
    parseInitialDump: (data, uniqueKey) =>{
        const {version, records} = data && data.kwargs || {};
        const newState = {version, records};
        // for (const record of records){
        //     newState.records[record[uniqueKey]] = record;
        // }
        return newState;
    },

    // updates validator - if an update is understood by the client an can be merged
    validateUpdate: data => data && data.kwargs && data.kwargs.records && data.kwargs.version
            && (data.kwargs.type && (data.kwargs.type === 'CREATE' || data.kwargs.type === 'UPDATE' || data.kwargs.type === 'DELETE')
                    || (data.kwargs.messageType && data.kwargs.messageType === 'UPDATE')),

    // validate an error update type
    isErrorUpdate: data => data && data.kwargs && data.kwargs.error,

    // updates parser - reformat data pushed
    parseUpdate: (data, uniqueKey) =>{
        const {messageType, type, version, records} = data && data.kwargs;
        const newUpdate = {version, type, messageType, records};
        //
        // if (messageType === 'UPDATE' || messageType === 'INITIAL_DUMP'){
        //     return newUpdate;
        // } else {
        //     if (type === 'CREATE'){
        //         for (const record of records){
        //             // newUpdate.records[record[uniqueKey]] = record;
        //             newUpdate.records
        //         }
        //     } else {
        //         newUpdate.records = records;
        //     }
        // }
        return newUpdate;
    },

    // subscription error - ex.: invalid match id
    isSubscriptionError: data => data && data.kwargs && data.kwargs.error,

    // merging strategy, this will be applied on non-indexed data
    // all the parsing above should already be applied, be wary of data format inconsistencies
    // because this is the function that merges updates into current state, pre-index
    // - brings the data to an initialDump format, you can index records by uniquekey
    mergeUpdates: (currentState, updates) =>{
        const newState = Object.assign({}, currentState);
        newState.records = [...currentState.records];
        for (const update of updates){
            const {messageType, type, records, version} = update;
            if (Number(version) >= Number(newState.version)){
                newState.version = version;

                if (messageType === 'UPDATE'){// apiVersion4
                    for (const record of records){
                        switch (record.changeType){
                            case 'CREATE':
                                newState.records = [...newState.records.filter(fi => !(fi.id === record.id && fi._type === record.entityType)), record.entity];
                                break;
                            case 'UPDATE':
                                const found = newState.records.find(fi => fi.id === record.id && fi._type === record.entityType);
                                const newRecord = Object.assign({}, found);
                                if (found){
                                    for (const key of Object.keys(record.changedProperties)){
                                        newRecord[key] = record.changedProperties[key];
                                    }
                                    newState.records = [...newState.records.filter(fi => !(fi.id === record.id && fi._type === record.entityType)), newRecord];
                                }
                                break;
                            case 'DELETE':
                                newState.records = newState.records.filter(fi => !(fi.id === record.id && fi._type === record.entityType));
                                break;
                        }
                    }
                    return newState;
                } else if (typeof type !== 'undefined'){
                    switch (type){
                        case 'CREATE':
                            for (const record of records){
                                newState.records = [...newState.records.filter(fi => !(fi.id === record.id)), record];
                            }
                            break;
                        case 'UPDATE':
                            for (const record of records){
                                const found = newState.records.find(fi => fi.id === record.id);
                                if (found){
                                    const newRecord = Object.assign({}, found, record);
                                    newState.records = [...newState.records.filter(fi => !(fi.id === newRecord.id && fi._type === newRecord._type)), newRecord];
                                }
                            }
                            break;
                        case 'DELETE':
                            for (const id of records){
                                newState.records = newState.records.filter(fi => !(fi.id === id));
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        return newState;
    },

    // unique key to process updates by
    uniqueKey: 'id',

    // initialDump endpoint to call
    initialDumpEndpoint: '/sports#initialDump',

    // another endpoint to call before unregistering - this is to ensure nodes actually unregister
    unregisterEndpoint: '/sports#doUnregister',

    // when calls fail recoverably, retry after this amount of time (minimum)
    // @TODO: retry_delay_growth and retry_delay_jitter from autobahn reconnect logic
    retryAfter: 3000,

    // subscribers processing frequency
    subscribersProcessingFrequency: 1000 / 60,
};


/**
 * List Updates Handlers
 */
let handlersIndex = 0;

const onSubscriptionsUpdateHandlers = {};
const onSubscribersUpdateHandlers = {};
const subscriptionsList = {};
const subscribersList = {};

// Logic to attach a handler
function addHandler(handlers = {}, fn = () =>{
}){
    const handlerIndex = ++handlersIndex;
    const targetHandlers = handlers;
    targetHandlers[handlerIndex] = fn;
    return () =>{
        delete targetHandlers[handlerIndex];
    };
}

// Logic to call all attached handlers
function callHandlers(handlers = {}, params = []){
    for (const handlerIndex of Object.keys(handlers)){
        if (typeof handlers[handlerIndex] === 'function'){
            handlers[handlerIndex](...params);
        }
    }
}

// Retrieve coalesced subscribers list
function getSubscriptionsList(){
    const r = [];
    for (const methodName of Object.keys(subscriptionsList)){
        for (const callId of Object.keys(subscriptionsList[methodName])){
            r.push(subscriptionsList[methodName][callId]);
        }
    }
    return r;
}

function getSubscribersList(){
    const r = [];
    for (const methodName of Object.keys(subscribersList)){
        for (const callId of Object.keys(subscribersList[methodName])){
            r.push(subscribersList[methodName][callId]);
        }
    }
    return r;
}

/**
 * onSubscriptionsUpdate - attaches handlers - bound to api.onSubscriptionsUpdate
 */
export function onSubscriptionsUpdate(fn = () =>{
}){
    return addHandler(onSubscriptionsUpdateHandlers, fn);
}

/**
 * onSubscribersUpdate - attaches handlers - bound to api.onSubscribersUpdate
 */
export function onSubscribersUpdate(fn = () =>{
}){
    return addHandler(onSubscribersUpdateHandlers, fn);
}

/**
 * provideOMFETopic
 */
export default function provideOMFETopic(subscribeMethodName = '', unsubscribeMethodName = '', preferredOptions = {}){
    /**
     * Options
     */
    const options = Object.assign({}, defaultOptions, preferredOptions);
    if (!options.topicName || typeof options.topicName !== 'function' || typeof options.topicName({}) !== 'string' || !options.topicName({}).length){
        throw new Error('Invalid topic name supplied to provideCall; must be a function that returns a string');
    }

    const {topicName} = options;

    /**
     * Subscribers Lists
     * - only subscribe/unsubscribe operates on these lists
     * - processor reacts to changes to these lists
     */
    const subscribers = {};
    const subscribersByTopic = {};
    let subscribersHaveChanged = false;
    const processor = new SubscribersProcessor(options);

    // subscribers processing task
    setInterval(() =>{
        if (subscribersHaveChanged){
            processor.updateSubscribers(subscribersByTopic);

            // Call Handlers
            subscribersList[subscribeMethodName] = Object.assign({}, subscribers);
            callHandlers(onSubscribersUpdateHandlers, [getSubscribersList()]);

            // Reset Subscribers Status
            subscribersHaveChanged = false;
        }
    }, options.subscribersProcessingFrequency);

    /**
     * Attach handler updates
     */
    processor.onSubscriptionsUpdate = (activeSubscriptions) =>{
        subscriptionsList[subscribeMethodName] = Object.assign({}, activeSubscriptions);
        callHandlers(onSubscriptionsUpdateHandlers, [getSubscriptionsList()]);
    };


    /**
     * unsubscribe - the opposite of subscribe
     */
    function unsubscribe(unsubscribeClientRequestId){
        if (!subscribers[unsubscribeClientRequestId]){
            return;
        }
        const {topic} = subscribers[unsubscribeClientRequestId];
        delete subscribers[unsubscribeClientRequestId];
        let i = -1;
        for (const subscriber of subscribersByTopic[topic]){
            i++;
            if (subscriber.clientRequestId === unsubscribeClientRequestId){
                subscribersByTopic[topic].splice(i, 1);
                break;
            }
        }

        // delete empty index
        if (!subscribersByTopic[topic].length){
            delete subscribersByTopic[topic];
        }

        subscribersHaveChanged = true;
    }


    /**
     * subscribe - called by clients - updates internal subscribers lists,
     */
    function subscribe({
                           clientRequestId = false,
                           params = {},
                           groupBy = false,
                           onPending = () =>{
                           },
                           onCompletion = () =>{
                           },
                           onUpdate = () =>{
                           },
                           onError = () =>{
                           },
                       }){
        if (!clientRequestId){
            throw new Error('The `clientRequestId` parameter is mandatory for OMFE subscriptions');
        }

        if (subscribers[clientRequestId]){
            throw new Error(`Already using ${clientRequestId} against ${subscribeMethodName}`);
        }

        // save the subscription
        const topic = topicName(params);
        subscribers[clientRequestId] = {
            clientRequestId,
            params,
            topic,
            groupBy,

            onPending,
            onCompletion,
            onUpdate,
            onError,

            removeSubscriber: () => unsubscribe(clientRequestId),
        };

        // create the index if not exists
        if (!subscribersByTopic[topic]){
            subscribersByTopic[topic] = [];
        }

        // add to index
        subscribersByTopic[topic].push(subscribers[clientRequestId]);

        // update status
        subscribersHaveChanged = true;
    }


    /**
     * Functions Go Back Into API Singleton
     */
    return {subscribeMethodName, subscribe, unsubscribeMethodName, unsubscribe};
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-provisioning/provideOMFETopic.js